// export const API_ADDRESS = 'http://localhost:1738';
export const API_ADDRESS = 'https://y-backend.com:1739';
export const S3_ADDRESS = 'https://s3-us-west-2.amazonaws.com/eventrooms-upload.y-backend.com';
